// @flow

import * as React from 'react';
import { Container, Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import type { State } from '../types';

type Props = {
  currentProduct: any,
  products: any
};

class OtherProducts extends React.Component<Props> {
  render() {
    const { products, currentProduct } = this.props;

    let difference = [];

    const BASE_URL = "https://live.roymorgan.com";

    if (products.length > 0) {
      // Product ID 407 is NEOs, which client requested to hide from this section.
      difference = products.filter(
        x => x.slug !== currentProduct.slug && x.slug !== 407
      );
    }

    return (
      <div className="page-row other-products page-row--background-white">
        <Container>
          <h2 className="text--cyan page-row__title">Our Other Products</h2>
          <Grid stackable>
            {difference.map((product, i) => {
              return (
                <Grid.Column
                  width={4}
                  computer={4}
                  tablet={6}
                  key={`other-product-${i}`}
                >
                  <div className="other-products__product">
                    <div className="other-products__product-icon">
                      {product.acf &&
                        product.acf.icon && (
                          <a href={BASE_URL +`/products/${product.slug}`}>
                            <div
                              className="callout__icon"
                              style={{
                                backgroundImage:
                                  'url(' + product.acf.icon.url + ')'
                              }}
                            />
                          </a>
                        )}
                    </div>
                    <div className="other-products__product-text">
                      {product.title && (
                        <h4 className="text--cyan">
                          <a href={BASE_URL + `/products/${product.slug}`}>
                            {ReactHtmlParser(product.title.rendered)}
                          </a>
                        </h4>
                      )}
                      {product.acf && (
                        <p>{ReactHtmlParser(product.acf.strapline)}</p>
                      )}
                    </div>
                  </div>
                </Grid.Column>
              );
            })}
          </Grid>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state: State) => {
  return {
    products: state.products.items
  };
};

// $FlowFixMe
export default connect(mapStateToProps)(OtherProducts);
